module.exports = __webpack_public_path__ + "static/hero2-3be9508ce1bc6f5d9c79352922a3c975.jpg";